export const settingKeys = {
  IS_PRICE_DROP_ENABLED_SETTING_KEY:
    'BusinessProfile.Roimatic.IsPriceDropEnabled',
  AUDIT_SKIP_SETTING_KEY: 'BusinessProfile.Roimatic.SkipAudit'
}
